import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { WorkOrderService } from '@app/services/work-order.service';

@Component({
  selector: 'formly-field-input-with-delete',
  template: `
    <div>
    <input type="input" [formControl]="formControl" [formlyAttributes]="field" style="width: 85%;">
    <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onRemove($event,to.id)"
      style="float: right;">
      <i class="material-icons left">delete</i>
      </button>
    </div>
  `,
})
export class FormlyFieldInputWithDelete extends FieldType {

  constructor(private workOrderService:WorkOrderService) {
    super();
  }

  onRemove($event,id) {

    console.log("llego al delete custom con id "+id);
    this.workOrderService.eliminarOrdenDeTrabajoComentario(id).subscribe(response=>{
      console.log('Comentario eliminado');
      window.location.reload();
    }),error=>{
      console.log('No se pudo eliminar el Comentario');
    },
    () => console.info('Comentario eliminado correctamente');
  }

}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
